// @flow
import type { Request } from '../index';

// DEPRECATED use GET_ALLOWANCES_LIST instead
type GetAllowancesResult = Array<string>

export const GET_ALLOWANCES: Request<
  void,
  GetAllowancesResult,
  void
> = [
    'food/allowances',
    'get',
    ['data', 'allowances'],
  ];
